import { getLocale } from "../runtime";

const sv_trackordertryagain = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Försök igen`
};

const trackordertryagain = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_trackordertryagain(inputs)
	return "trackOrderTryAgain";
};

export { trackordertryagain as "trackOrderTryAgain" };